function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.035,67c-0.148,0-0.299-0.01-0.448-0.029c-1.077-0.139-2.028-0.77-2.574-1.707L0.478,31.775 c-0.974-1.67-0.411-3.813,1.259-4.787c1.67-0.973,3.813-0.41,4.787,1.26l17.247,29.566l56.79-56.789c1.367-1.367,3.583-1.367,4.95,0 c1.367,1.366,1.367,3.583,0,4.949l-60,60C24.85,66.636,23.957,67,23.035,67"
});

var SvgConferma = function SvgConferma(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 88,
    height: 68,
    viewBox: "-0.639 -0.055 88 68",
    enableBackground: "new -0.639 -0.055 88 68",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgConferma, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/conferma.162bee48.svg";
export { ForwardRef as ReactComponent };